import loadable from "@loadable/component";

const jspdfLoadable = loadable.lib(() => import(/* webpackChunkName: "jspdf" */ "jspdf"));

export const exportPdf = async (html: string, fileName: string): Promise<void> => {
  const jspdf: any = await jspdfLoadable.load(); // TODO: fix TS
  const doc = new jspdf.jsPDF({
    orientation: "landscape",
    unit: "pt",
    format: "letter"
  });

  return doc.html(html, {
    margin: 20,
    filename: fileName,
    callback: (doc) => {
      doc.save(fileName);
    }
  });
};
